import api from '@/services/api/api';

export const useDocumentByCategorySlug = (slug) => {
  const categorySlug = useQuery(
    ['categorySlug', slug],
    async () => {
      const { data } = await api.documents.getDocumentsByCategorySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: (data) => data,
    },
  );
  /**
   * TODO: test onServerprefetch
   */
  onServerPrefetch(async () => {
    await categorySlug.suspense();
  });

  return {
    categorySlug,
  };
};
